import { render } from "./statistics_chart2.vue?vue&type=template&id=bd63d270"
import script from "./statistics_chart2.vue?vue&type=script&lang=js"
export * from "./statistics_chart2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__